import { c as _c } from "react-compiler-runtime";
import { Text } from "@/components/primitives";
import { cn } from "@/core/utils";
type LabelProps = {
  className?: string;
  htmlFor: string;
  id: string;
  text: string;
  invalid?: boolean;
};
export default function Label(t0) {
  const $ = _c(7);
  const {
    className,
    htmlFor,
    id,
    text
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("type-label-md block font-medium", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== htmlFor || $[3] !== id || $[4] !== t1 || $[5] !== text) {
    t2 = <label className={t1} htmlFor={htmlFor} id={id}>{text}</label>;
    $[2] = htmlFor;
    $[3] = id;
    $[4] = t1;
    $[5] = text;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}